import {applyMiddleware, compose, combineReducers} from 'redux';
import alertsReducer, {alertsInitialState} from './alerts';
import assetDragReducer, {assetDragInitialState} from './asset-drag';
import assistantReducer, {assistantInitialState} from './assistant';
import cardsReducer, {cardsInitialState} from './cards';
import colorPickerReducer, {colorPickerInitialState} from './color-picker';
import customProceduresReducer, {customProceduresInitialState} from './custom-procedures';
import blockDragReducer, {blockDragInitialState} from './block-drag';
import editorTabReducer, {editorTabInitialState} from './editor-tab';
import hoveredTargetReducer, {hoveredTargetInitialState} from './hovered-target';
import menuReducer, {menuInitialState} from './menus';
import micIndicatorReducer, {micIndicatorInitialState} from './mic-indicator';
import modalReducer, {modalsInitialState} from './modals';
import modeReducer, {modeInitialState} from './mode';
import monitorReducer, {monitorsInitialState} from './monitors';
import monitorLayoutReducer, {monitorLayoutInitialState} from './monitor-layout';
import projectChangedReducer, {projectChangedInitialState} from './project-changed';
import projectIdReducer, {projectIdInitialState} from './project-id';
import projectTitleReducer, {projectTitleInitialState} from './project-title';
import restoreDeletionReducer, {restoreDeletionInitialState} from './restore-deletion';
import stageSizeReducer, {stageSizeInitialState} from './stage-size';
import targetReducer, {targetsInitialState} from './targets';
import toolboxReducer, {toolboxInitialState} from './toolbox';
import vmReducer, {vmInitialState} from './vm';
import disguisedBlockReducer, {disguisedBlockInitialState} from './disguised-block';
import vmStatusReducer, {vmStatusInitialState} from './vm-status';
import throttle from 'redux-throttle';

import accountInfoReducer, {accountInfoInitialState} from './account-info.js';
import stageReducer, {stageInitialState} from './stage.js';
import homeworkReducer, {homeworkInitialState} from './homework';
import homeworkSaveReducer, {homeworkSaveInitialState} from './homework-save';
import decks from '../lib/libraries/decks/index.jsx';
import {getHomeworkInfo} from '../lib/homework-info';
import {getParameterByName} from '../utils/tools';

const guiMiddleware = compose(applyMiddleware(throttle(300, {leading: true, trailing: true})));

const guiInitialState = {
    alerts: alertsInitialState,
    assetDrag: assetDragInitialState,
    assistant: assistantInitialState,
    blockDrag: blockDragInitialState,
    cards: cardsInitialState,
    colorPicker: colorPickerInitialState,
    customProcedures: customProceduresInitialState,
    editorTab: editorTabInitialState,
    mode: modeInitialState,
    hoveredTarget: hoveredTargetInitialState,
    stageSize: stageSizeInitialState,
    menus: menuInitialState,
    micIndicator: micIndicatorInitialState,
    modals: modalsInitialState,
    monitors: monitorsInitialState,
    monitorLayout: monitorLayoutInitialState,
    projectChanged: projectChangedInitialState,
    projectId: projectIdInitialState,
    projectTitle: projectTitleInitialState,
    restoreDeletion: restoreDeletionInitialState,
    targets: targetsInitialState,
    toolbox: toolboxInitialState,
    vm: vmInitialState,
    vmStatus: vmStatusInitialState,
    accountInfo: accountInfoInitialState,
    stage: stageInitialState,
    homework: homeworkInitialState,
    homeworkSave: homeworkSaveInitialState,
    disguisedBlock: disguisedBlockInitialState,
};

const initPlayer = function (currentState) {
    return Object.assign(
        {},
        currentState,
        {mode: {
            isFullScreen: currentState.mode.isFullScreen,
            isPlayerOnly: true
        }}
    );
};
const initFullScreen = function (currentState) {
    return Object.assign(
        {},
        currentState,
        {mode: {
            isFullScreen: true,
            isPlayerOnly: currentState.mode.isPlayerOnly
        }}
    );
};

const initTutorialCard = function (currentState, deckId) {
    return Object.assign(
        {},
        currentState,
        {
            modals: {
                previewInfo: false
            },
            cards: {
                visible: true,
                content: decks,
                activeDeckId: deckId,
                step: 0,
                x: 0,
                y: 0,
                dragging: false
            }
        }
    );
};

const guiReducer = combineReducers({
    alerts: alertsReducer,
    assetDrag: assetDragReducer,
    assistant: assistantReducer,
    blockDrag: blockDragReducer,
    cards: cardsReducer,
    colorPicker: colorPickerReducer,
    customProcedures: customProceduresReducer,
    editorTab: editorTabReducer,
    mode: modeReducer,
    hoveredTarget: hoveredTargetReducer,
    stageSize: stageSizeReducer,
    menus: menuReducer,
    micIndicator: micIndicatorReducer,
    modals: modalReducer,
    monitors: monitorReducer,
    monitorLayout: monitorLayoutReducer,
    projectChanged: projectChangedReducer,
    projectId: projectIdReducer,
    projectTitle: projectTitleReducer,
    restoreDeletion: restoreDeletionReducer,
    targets: targetReducer,
    toolbox: toolboxReducer,
    vm: vmReducer,
    vmStatus: vmStatusReducer,
    accountInfo: accountInfoReducer,
    stage: stageReducer,
    homework: homeworkReducer,
    homeworkSave: homeworkSaveReducer,
    disguisedBlock: disguisedBlockReducer,
});
window.onload = function (){
    localStorage.setItem('stageDisplayMode', 'small');
    let timeout = false;
    const timeId = () => {
        if (timeout) return;
        const homeworkInfo = getHomeworkInfo();
        const courseId = Number(homeworkInfo.courseId);
        const unitId = Number(homeworkInfo.unitId);
        const lessonId = Number(homeworkInfo.lessonId);
        const homeworkId = getParameterByName('homeworkId');
        if (lessonId !== 0 || homeworkId) {
            ht.track('s3_launch', {
                context: {
                    courseId: courseId,
                    unitId: unitId,
                    lessonId: lessonId,
                    currentUrl: location.href,
                    stageDisplayMode: localStorage.getItem('stageDisplayMode')
                }
            });
            sa.track('s3_launch');
            timeout = true;
        }
        setTimeout(timeId, 500);
    };
    timeId();
};


export {
    guiReducer as default,
    guiInitialState,
    guiMiddleware,
    initFullScreen,
    initPlayer,
    initTutorialCard
};
